import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';
import { ToolsProvider } from '../../../providers/tools/tools';
import { ModalController } from 'ionic-angular';
import { UserProvider } from '../../../providers/user/user';
import { CrudApiProvider } from '../../../providers/crud-api/crud-api';
import { LiveChatProvider } from '../../../providers/live-chat/live-chat';

@Component({
  selector: 'lc-giveaway-announcement',
  templateUrl: 'sponsorship-giveaway-announcement.html',
})
export class LiveChatGiveAwayComponent {
  log = debug('app:LiveChatGiveAwayComponent');

  @Output() timeForGiveAway = new EventEmitter();
  @Output() joinedGiveAway = new EventEmitter();
  @Output() close = new EventEmitter();
  @Input() sponsor: boolean = true;
  @Input() entryConfirmed = false;
  @Input() eventInfo;
  @Input() currentPage: string;

  constructor(
    public tools: ToolsProvider,
    public modalCtrl: ModalController,
    public userProvider: UserProvider,
    public crudApi: CrudApiProvider,
    public liveChat: LiveChatProvider
  ) {}

  async ngOnInit() {
    this.log('AdTags', this.eventInfo);
    const cId = _.get(this.eventInfo, 'advertiser.conversationId');
    const hasJoined = await this.liveChat.hasJoinedRoom(cId);
    this.entryConfirmed = hasJoined;
  }

  enterGiveaway() {
    const conversation_id = _.get(this.eventInfo, 'advertiser.conversationId');

    if (!this.entryConfirmed) {
      if (this.currentPage !== 'ChatPage') {
        this.tools.navTo('ChatPage', 1, { conversation_id });
      }
      this.liveChat.join(conversation_id);
      this.joinedGiveAway.emit(true);
    } else {
      this.close.emit();
    }
  }

  closeAndIgnore() {
    this.close.emit();
    localStorage.setItem('cdlc-ignored-contest--' + _.get(this.eventInfo, 'advertiser.conversationId'), 'true');
  }
}



// WEBPACK FOOTER //
// ./src/components/_live-chat/sponsorship-giveaway-announcement/sponsorship-giveaway-announcement.ts